<template>
  <div class="date-picker">
    <div class="date-picker__label-box">
      <label
        required
        :class="`v-label ${required ? '--required__label': ''}`"
      >
        {{label}}
      </label>
    </div>
    <div class="date-picker__date-box">
      <v-date-picker
        class="date-picker__date"
        v-if="dates"
        locale="pt"
        color="primary"
        prev-icon="bexsicon-left"
        next-icon="bexsicon-right"
        no-title
        :allowed-dates="allowedDates"
        v-model="date"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "date-picker",
  props: {
    label: String,
    required: Boolean,
    dates: Array,
    changeDate: Function
  },
  data () {
    return {
        date : new Date().toISOString().substr(0, 10)
    }
  },
  created(){
    if(this.dates.length > 0){
      this.date = this.dates[0].date
    }
  },
  methods : {
    allowedDates (val) {
      let test = this.dates.find( item => item.date === val)
      return !!test
    }
  },
  watch: {
    date: function () {
      this.changeDate(this.date)
    },
    dates: function () {
      if(this.dates.length > 0) {
        this.date = this.dates[0].date
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.date-picker{
  display: block;
  padding: 0.7rem;
  &__date-box {
    display: flex;
    height: 100%;
    .v-card {
      border: 1px solid #CCCCCC;
      border-radius: 4px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/fields/DatePicker.vue